import { SET_COUNT } from "../../constants/ActionTypes";

export const setCount = (props) => {
  return (dispatch) => {
    dispatch({ type: SET_COUNT, payload: props });
  };
};
